import { generatePath } from '@helpers';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { appPaths } from '@terminal/routes/app-paths';
import { queryKeys } from '@terminal/routes/query-params';
import { NavigateToKgInsightParams } from '@terminal/services/tracking/posthog/use-posthog-events/insightsEventTypes';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useNavigate } from 'react-router';

export const useNavigateToKgInsight = () => {
  const navigate = useNavigate();
  const { params } = useQueryParams();
  const { trackKgInsightReadFullCatalyst } = usePosthogEvents();

  const navigateToKgInsight = ({
    source,
    category,
    insightId,
  }: NavigateToKgInsightParams) => {
    if (!insightId) {
      return;
    }

    const preservedParams = [queryKeys.earningsId] as const;

    const queryParams: Record<string, string | number> = {
      [queryKeys.source]: source,
      [queryKeys.insightId]: insightId,
    };

    for (const param of preservedParams) {
      const value = params[param];
      if (value) {
        queryParams[param] = value;
      }
    }

    if (category === 'earnings_preview' || category === 'earnings_recap') {
      queryParams[queryKeys.activeDrawerTab] = category;
    }

    trackKgInsightReadFullCatalyst({
      source,
      category,
      insightId,
    });

    navigate(
      generatePath({
        basePath: appPaths.kgInsight,
        params: queryParams,
      })
    );
  };

  return { navigateToKgInsight };
};
